import './MissingDocumentIcon.scss';

export type MissingDocumentIconProps = {
  className?: string;
};

/**
 * A document nobody has uploaded: an empty dashed slot with a question mark,
 * the same glyph the consolidation ledger draws for a gap in a chain.
 *
 * Takes the place of an icon component (see `getIconFromFileType`), so it
 * accepts the className a tree row gives its icon, and keeps an icon-sized box
 * around the glyph so the row's name lines up with its neighbours. It is drawn
 * in `currentColor`, so it takes whatever colour its row or title has.
 */
export const MissingDocumentIcon = ({ className }: MissingDocumentIconProps) => (
  <span
    className={
      className ? `${className} missing-document-icon` : 'missing-document-icon'
    }
    aria-hidden="true"
  >
    <span className="missing-document-icon__glyph">?</span>
  </span>
);

export default MissingDocumentIcon;
